__turbopack_context__.v({
  "footerButton": "PNTE7q_footerButton",
  "footerQuantityButton": "PNTE7q_footerQuantityButton",
  "footerQuantityValue": "PNTE7q_footerQuantityValue",
  "footerQuantityWrapper": "PNTE7q_footerQuantityWrapper",
});
